import { lang } from '@dhxete/util';

export default lang;
